import { Component, OnInit } from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {PromotionList} from '../../../../models/promotions/promotion-list.model';
import {Filter} from '../../../../models/warranties/filter.model';
import {WarrantyList} from '../../../../models/warranties/warranty-list.model';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-promotions',
  templateUrl: './admin-promotions.component.html',
  styleUrls: ['./admin-promotions.component.scss']
})
export class AdminPromotionsComponent implements OnInit {

  promotionList: PromotionList;
  filter: Filter = new Filter();

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList() {
    this.http.fetchAdminPromotions(this.filter).subscribe((res) => {
      this.promotionList = Object.assign(new PromotionList(), res);
    });
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      }
      else { this.filter.order = 'ASC'; }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  showDirectionImage(): string {
    if (this.filter.order === 'ASC') { return 'assets/images/icon-sort-up.png'; }
    else { return 'assets/images/icon-sort-down.png'; }
  }

  clearFilter() {
    this.filter = new Filter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }

  downloadPromotionFile(id: number, d: string) {
    return this.http.downloadFile(id, d);
  }
}
